// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Fade from "@mui/material/Fade";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

import DefaultNavbarLayout from "layouts/defaultNavbar";
import Footer from "layouts/footer";

// Images
import whatsappVentas from "assets/images/whatsapp-ventas.png";
//import whatsappServicios from "assets/images/whatsapp-servicios.png";
import CenteredBriefBlogCard from "examples/Cards/BlogCards/CenteredBriefBlogCard";

function Home() {
  // const imgChery = require("assets/images/logo/logo-chery.jpg");
  const imgDfsk = require("assets/images/logo/logo-dfsk.jpg");
  const imgJac = require("assets/images/logo/logo-jac.jpg");
  const imgHeader = require("assets/images/shouer_header.jpg");


  return (
    <>
      <DefaultNavbarLayout />
      <MKBox
        position="relative"
        display="flex"
        alignItems="flex-start"
        minHeight="100vh"
        pt={18}
        sx={{ overflow: "hidden" }}
      >
        {/* Imagen de fondo con fade */}
        <Fade in='true' timeout={600}>
          <MKBox
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            zIndex={0}
            sx={{
              style: "object-fit: cover",
              backgroundImage: ({
                palette: { gradients },
                functions: { linearGradient, rgba },
              }) =>
                `${linearGradient(
                  rgba(gradients.dark.main, 0.5),
                  rgba(gradients.dark.state, 0.1)
                )}, url(${imgHeader})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "background-image 0.6s cubic-bezier(0.4,0,0.2,1)",
            }}
          />
        </Fade>


      </MKBox>

      <Card
        sx={{
          p: 2,
          pb: 0,
          mx: { xs: 2, lg: 3 },
          mt: -4,
          mb: 2,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={6}>
          <Container>
            <Grid container item xs={12} justifyContent="center">
              <MKTypography variant="h3" mb={8}>
                Nuestras marcas
              </MKTypography>
            </Grid>

            <Grid container spacing={3} justifyContent="center">
              {/* <Grid item xs={12} sm={6} lg={3}>
                <MKBox mb={6}>
                  <CenteredBriefBlogCard
                    image={imgChery}
                    action={{
                      type: "internal",
                      route: "/chery",
                      color: "info",
                      label: "ver más",
                      border: true,
                    }}
                  />
                </MKBox>
              </Grid> */}
              <Grid item xs={12} sm={6} lg={3}>
                <MKBox mb={6}>
                  <CenteredBriefBlogCard
                    image={imgDfsk}
                    action={{
                      type: "internal",
                      route: "/dfsk",
                      color: "info",
                      label: "ver más",
                      border: true,
                    }}
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <MKBox mb={6}>
                  <CenteredBriefBlogCard
                    image={imgJac}
                    action={{
                      type: "internal",
                      route: "/jac",
                      color: "info",
                      label: "ver más",
                      border: true,
                    }}
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>


        <MKBox
          component="section"
          variant="gradient"
          bgColor="dark"
          position="relative"
          py={6}
          px={{ xs: 2, lg: 0 }}
          mx={-2}
          sx={{ "border-bottom-left-radius": "0.5rem", "border-bottom-right-radius": "0.5rem" }}
        >
          <Container>
            <Grid container justifyContent={"center"} textAlign={"center"}>
              <Grid item xs={12} md={8} sx={{ mb: 6 }}>
                <MKTypography variant="h3" color="white">
                  Contacta por whatsapp
                </MKTypography>
                <MKTypography variant="body2" color="white" opacity={0.8}>
                  Escribe por whatsapp para más información sobre nuestros vehículos y servicios.
                  <br />Nuestro equipo está listo para ayudarte a encontrar el auto perfecto para ti.
                </MKTypography>
              </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <HorizontalTeamCard
                    image={whatsappVentas}
                    name="Ventas"
                    position={{ color: "info", label: "" }}
                    description="011 2299-1555"
                    link="https://shouer.com.ar/track.php?c=whatsapp&p=ventas&o=web"
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <Footer />
    </>
  );
}

export default Home;
